/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
import React from 'react';

const IconDelete = ({ classNames }) => {
  const classes = `${classNames}`;
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M3.99976 7.5H19.9998"
        stroke="#344054"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99976 11.5V17.5"
        stroke="#344054"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0002 11.5V17.5"
        stroke="#344054"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.00024 7.5L6.00024 19.5C6.00024 20.0304 6.21096 20.5391 6.58603 20.9142C6.9611 21.2893 7.46981 21.5 8.00024 21.5H16.0002C16.5307 21.5 17.0394 21.2893 17.4145 20.9142C17.7895 20.5391 18.0002 20.0304 18.0002 19.5L19.0002 7.5"
        stroke="#344054"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 7.5V4.5C9 4.23478 9.10536 3.98043 9.29289 3.79289C9.48043 3.60536 9.73478 3.5 10 3.5H14C14.2652 3.5 14.5196 3.60536 14.7071 3.79289C14.8946 3.98043 15 4.23478 15 4.5V7.5"
        stroke="#344054"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

IconDelete.defaultProps = {
  classNames: '',
};

IconDelete.propTypes = {
  classNames: PropTypes.string,
};

export default IconDelete;
